
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useModal } from 'context';
import { Login } from 'modals';
import HomePage from 'views/HomePage';

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const uid = searchParams.get('uid');
  const rt = searchParams.get('rt');
  const rtp = searchParams.get('rtp');

  useEffect(() => {
    console.log('[LoginPage] Opening login modal with params:', { uid, rt, rtp });
    
    // Store return parameters in sessionStorage for after login
    if (rt || rtp || uid) {
      sessionStorage.setItem('loginReturnRT', rt || '');
      sessionStorage.setItem('loginReturnRTP', rtp || '');
      sessionStorage.setItem('loginReturnUID', uid || '');
    }

    // Open login modal when this page loads
    openModal({
      content: <Login />,
      title: uid ? "Admin Impersonation" : "Login",
      onClose: () => {
        // Clear stored return params on modal close
        sessionStorage.removeItem('loginReturnRT');
        sessionStorage.removeItem('loginReturnRTP');
        sessionStorage.removeItem('loginReturnUID');
        
        // Close modal and navigate back
        closeModal();
// if (document.referrer && document.referrer.includes('/auth/auth-endpoint')) {
//       navigate('/');
//     } else {
//       navigate(-1);
//     }      
  }
    });

    // Clean up on unmount
    return () => {
      closeModal();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Render the homepage as background with the modal overlay
  return <HomePage />;
};

export default LoginPage;